import {
  getParentNode,
  insertNode,
  insertNodes,
  isEditor,
  isText,
} from '@udecode/plate';
import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { NEW_LINE_REGEX } from './constants';
import { ParagraphElement } from './nodes/ParagraphElement';
import { nodeIsChildOfParagraph } from './queries/nodeIsChildOfParagraph';

export const parseTextAndInsertParagraphs = (
  editor: BufferEditor,
  text: string,
  _insertText: (text: string) => void
) => {
  // This regex matches newline characters or carriage returns
  // or new lines text literally, making sure to capture any
  // version of a new line
  const splitText = text.split(NEW_LINE_REGEX);
  let linesToParse = splitText;

  // If the current node under the selection is a direct
  // child of a paragraph node, simply insert the first
  // line of text instead of adding it to its own paragraph
  if (nodeIsChildOfParagraph(editor)) {
    const [firstLine, ...remainingLines] = linesToParse;
    _insertText(firstLine);
    linesToParse = remainingLines;
  }

  // Add all or the remaining lines to their own paragraphs
  const paragraphNodes = linesToParse.map((line) =>
    ParagraphElement.new([{ text: line }])
  );

  return insertNodes(editor, paragraphNodes);
};

export const withParagraph = (editor: BufferEditor) => {
  const {
    insertData: _insertData,
    insertText: _insertText,
    normalizeNode: _normalizeNode,
  } = editor;

  editor.normalizeNode = ([node, path]) => {
    const parentNodeEntry = getParentNode(editor, path);
    const shouldParseAndWrapNode =
      !isEditor(node) && isEditor(parentNodeEntry?.[0]) && isText(node);

    if (shouldParseAndWrapNode) {
      const paragraphNodes = ParagraphElement.paragraphsFromText(node.text);
      return insertNode(editor, paragraphNodes);
    }
    return _normalizeNode([node, path]);
  };

  editor.insertText = (text) => {
    if (NEW_LINE_REGEX.test(text)) {
      return parseTextAndInsertParagraphs(editor, text, _insertText);
    }
    _insertText(text);
  };

  editor.insertData = (data) => {
    const text = data.getData('text/plain');
    if (text) {
      return parseTextAndInsertParagraphs(editor, text, _insertText);
    }
    _insertData(data);
  };

  return editor;
};
